import type { ComponentProps } from 'react';
import React from 'react';

import Separator from 'common/components/Separator';

const StyledSeparator = (props: ComponentProps<typeof Separator>) => (
  <Separator display={['none', null, 'block']} {...props} />
);
export default StyledSeparator;
